module.exports = __webpack_public_path__ + "img/user.d080ac88.jpg";